export class PesquisaFiltro{
    public Discriminacao: string;
    public DataInicial: string;
    public DataFinal: string;
    public Pagina: number;
}